export const environment = {production: true , API:  "https://sd-apirm.pcdoc.com.br/api"  , APIpublic:  "https://sd-apirm.pcdoc.com.br/public/usuario" , AlfrescoAPI:  "https://sd.pcdoc.com.br" , URL_SURFACE:  "https://sd-surface.pcdoc.com.br/" , URL_WORKSPACE:  "https://sd.pcdoc.com.br/" , URL_RM:  "https://sd-rm.pcdoc.com.br/" , siteKeyCapctha:  "6LfJI38oAAAAAF4VIQgqL_LlS9_ZA3uREDLJwYcT" , keyCriptAttempts:  "zRJmF*p4&L9SsP#vKt@yUxQa2WcVbN" }



// WEBPACK FOOTER //
// /app/src/environments/environment.prod.ts